import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const AutoCarousel = () => {
  const slides = [
    "/assets/service-sec-1.jpeg",
    "/assets/communityDevelopement.jpg",
    "/assets/custom-Homes.jpg",
    "/assets/Interior-Desigm-service-page.jpg",
  ];

  return (
    <div
      className="relative w-full h-[80vh] overflow-hidden group"
      onMouseEnter={(e) => e.target.swiper?.autoplay.stop()}
      onMouseLeave={(e) => e.target.swiper?.autoplay.start()}
    >
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/20 to-transparent z-10 pointer-events-none"></div>

      {/* Swiper Carousel */}
      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        loop
        speed={1000}
        className="h-full"
      >
        {slides.map((img, i) => (
          <SwiperSlide key={i}>
            <img
              src={img}
              alt={`Slide ${i + 1}`}
              className="w-full h-full object-cover"
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Optional: custom navigation buttons (if you want styled arrows) */}
      <style>
        {`
          .swiper-button-prev,
          .swiper-button-next {
            color: white;
            transition: opacity 0.3s ease;
            opacity: 0;
          }
          .group:hover .swiper-button-prev,
          .group:hover .swiper-button-next {
            opacity: 1;
          }
        `}
      </style>
    </div>
  );
};

export default AutoCarousel;
